// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + {"329":"perm","371":"connect","934":"linguistConnect","962":"home","966":"login"}[chunkId] + ".css"; };